import React, { Component } from 'react';
import {
  Grid,
  Select,
  FormControl,
  MenuItem,
  FormControlLabel,
  Checkbox,
  Button,
} from '@material-ui/core';
import '../../css/ivrs/ivrsModal.scss';
import ModalHOC from '../common/Modal/index';

export default class FreeTrialModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClose = () => {
    const { onClose } = this.props;
    onClose(false);
  };

  render() {
    const { showModal } = this.props;
    return (
      <React.Fragment>
        <ModalHOC
          isOpen={showModal}
          customContent="free-trial-modal"
          onClose={this.handleClose}
        >
          <Grid container>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <section className="section__left">
                <h1>Sed ut perspiciatis unde omnis iste natus error.</h1>
                <h2>Start your 7 day free trial</h2>
                <h3>With farm engine you can-</h3>
                <p>
                  <i className="material-icons">check_circle</i>
                  Monitor farms
                </p>
                <p>
                  <i className="material-icons">check_circle</i>
                  Target and connect with farmers
                </p>
                <p>
                  <i className="material-icons">check_circle</i>
                  Send advisory and notifications to your farmers
                </p>
                <p>
                  <i className="material-icons">check_circle</i>
                  Crop monitoring
                </p>
                <img src="images/free-trial.png" alt="img" />
              </section>
            </Grid>
            <Grid item lg={6} md={6} sm={6} xs={12}>
              <section>
                <span>
                  <i className="material-icons">close</i>
                </span>
                <h4>Sign up to start your free trial</h4>
                <Grid container>
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    <h5>Full name</h5>
                    <input
                      placeholder="type here"
                      className="textField inputHead  textfield"
                      maxLength={6}
                      // onChange={this.handlePincodeChange}
                      // value={pincode}
                    />
                    <h5> Work Email</h5>
                    <input
                      placeholder="type here"
                      className="textField inputHead  textfield"
                      maxLength={6}
                      // onChange={this.handlePincodeChange}
                      // value={pincode}
                    />
                    <h5>Job Title</h5>
                    <FormControl className="formControl inputHead coloredForms inputFullWidth">
                      <Select
                        disableUnderline
                        name="dashboard-user"
                        className="selectEmpty modalDropdown"
                        inputProps={{ 'aria-label': 'user' }}
                        // value={satellitesSource}
                        displayEmpty
                        //  onChange={ev => this._handleSatelliteSource(ev)}
                      >
                        <MenuItem>Select</MenuItem>
                      </Select>
                    </FormControl>
                    <h5>Company Name</h5>
                    <input
                      placeholder="type here"
                      className="textField inputHead  textfield"
                      maxLength={6}
                      // onChange={this.handlePincodeChange}
                      // value={pincode}
                    />
                    <h5>Phone Number</h5>
                    <input
                      placeholder="type here"
                      className="textField inputHead  textfield"
                      maxLength={6}
                      // onChange={this.handlePincodeChange}
                      // value={pincode}
                    />
                    <h5>Country</h5>
                    <input
                      placeholder="type here"
                      className="textField inputHead  textfield"
                      maxLength={6}
                      // onChange={this.handlePincodeChange}
                      // value={pincode}
                    />
                  </Grid>
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    className="centerAlign"
                  >
                    <FormControlLabel
                      control={<Checkbox value="checkedB" color="primary" />}
                      label="I agree to terms & conditions and privacy policy."
                      className="acknowledgeCheckbox"
                    />
                    <Button>Start Free Trial</Button>
                  </Grid>
                </Grid>
              </section>
            </Grid>
          </Grid>
        </ModalHOC>
      </React.Fragment>
    );
  }
}
